import cn from 'classnames';

import useIsScreenSize from 'js/hooks/use-is-screen-size';

import Heading from 'components/heading/Heading';
import Metadata from 'components/metadata/Metadata';
import Message from 'components/message/Message';
import Tags from 'components/tags/Tags';
import Status from 'components/status/Status';
import Icon from 'components/icon/Icon';
import StepTag from 'components/step-tag/StepTag';

import { IProposal } from 'source/NFR.types';

interface ProposalProps extends IProposal {
  headingLevel?: 2 | 3 | 4;
}

const Proposal: React.FC<ProposalProps> = ({
  dateLabel,
  date,
  mobileDate,
  year,
  status,
  title,
  metadata,
  text,
  tags,
  isInternational,
  url,
  messageList,
  headingLevel,
  applicationSystemTag,
  groupTag
}) => {
  const isDesktop = useIsScreenSize('md');

  return (
    <div className="proposal">
      <div className="proposal--left">
        <div className={cn('proposal--date', status.theme)}>
          <div className="proposal--date-label">{dateLabel}</div>
          <time dateTime={date} className="proposal--date-date">
            {isDesktop ? date : mobileDate}
          </time>
          <time dateTime={year} className="proposal--date-year">
            {year}
          </time>
        </div>
        {isInternational && (
          <div>
            <Icon className="proposal--globe-icon" name="globe" />
          </div>
        )}
        {(applicationSystemTag || groupTag) && (
          <div className="proposal--step-tags">
            {applicationSystemTag && <StepTag label={applicationSystemTag} variant="application-system" />}
            {groupTag && <StepTag label={groupTag} />}
          </div>
        )}
      </div>
      <div className="proposal--right">
        {status && <Status {...status} />}
        <a className="proposal--link" href={url}>
          <Heading className="proposal--title" level={headingLevel}>
            <span>{title}</span>
          </Heading>
        </a>
        {messageList?.map(message => (
          <div key={message?.text?.text} className="date-card--message">
            <Message {...message} />
          </div>
        ))}
        {metadata && <Metadata {...metadata} theme="vertical" />}
        <p className="proposal--text">{text}</p>
        {tags && <Tags {...tags} />}
      </div>
    </div>
  );
};

Proposal.displayName = 'Proposal';

export default Proposal;
